import { render, staticRenderFns } from "./SysCodeItem.vue?vue&type=template&id=37c8a93c&"
import script from "./SysCodeItem.vue?vue&type=script&lang=js&"
export * from "./SysCodeItem.vue?vue&type=script&lang=js&"
import style0 from "./SysCodeItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports